<ng-container *ngIf="dialect">
  <div class="tooltip-head-box dialect">

    <div class="place-label-list">
      <div *ngIf="dialect.area1"
           class="place-label-box main-type{{ GetRegion2Css(dialect.area1) }}">{{ GetRegion2Name(dialect.area1) }}</div>

      <!-- div *ngIf="dialect.area2"
           class="place-label-box sub-type{{ GetRegion2Css(dialect.area1) }}">{{ dialect.area2 }}</div -->
    </div>

    <a *ngIf="btnClose"
       class="tooltip-close-btn"
       (click)="onClose($event)"></a>

  </div>

  <div class="tooltip-body-box">
    <div class="dialect">{{ dialect.word }}</div>
  </div>

  <div class="tooltip-foot-box">
    <ng-container *ngFor="let meaning2 of dialect.meaning2; let idx = index">

      <div *ngIf="dialect.GetMeaning2Nth(idx)"
           class="meaning-box">
        <div class="mean-txt flex">

          <div *ngIf="idx > 0"
               class="txt-box-num">{{ idx }}.</div>

          <div class="txt-box-meaning"
               [innerHTML]="dialect.GetMeaning2Nth(idx) | resize | keepHtml"></div>

        </div>
      </div>

    </ng-container>
    <!-- div class="tooltip-txt-box"
         [innerHTML]="dialect.meaning2 | resize | keepHtml">
    </div -->
  </div>

  <div class="tooltip-link-box">
    <a class="tooltip-link-btn"
       (click)="onGotoDetail($event)">

      <span class="txt">자세히 보기</span>
      <i class="ic ic-link"></i>
    </a>
  </div>

</ng-container>
